//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
	name: 'Header',
	data() {
		return {
			heading: this.$root.mainHeading
		}
	},
	computed: {
		...mapGetters(["socialData"]),
		posts() {
			return [this.socialData.posts.items[0], this.socialData.posts.items[1]];
		},
		iconClasses() {
			if (this.posts[0].source.source === this.posts[1].source.source) {
				return ["blue-icon-" + this.posts[0].source.source.toLowerCase()];
			} else {
				return ["blue-icon-" + this.posts[0].source.source.toLowerCase(), "blue-icon-" + this.posts[1].source.source.toLowerCase()];
			}
		}
	},
	methods: {},
	mounted() {

	}
}
